import { Component, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-profile',
  imports: [AsyncPipe],
  template: `
    @if (auth.isLoading$ | async) {
      <div class="loading-text">Loading profile...</div>
    }
    
    @if ((auth.isAuthenticated$ | async) && (auth.user$ | async); as user) {
      <div class="profile-container">
        
        <div class="profile-info">
          <div class="profile-name">
            {{ user.name }}
          </div>
        </div>
        @if (user.picture) {
          <img 
            [src]="user.picture" 
            [alt]="user.name || 'User'"
            class="profile-picture"
          />
        }
      </div>
    }
  `,
  styleUrl: '../../styles/profile.component.scss'
})
export class ProfileComponent {
  protected auth = inject(AuthService);
}